import React from "react";
import { Button, Stack } from "@mui/material";
import theme from "../../configs/theme";

export default function ButtonsMenu({ selected, onAction, rol }) {

  const handleClick = (action) => {
    onAction(action);
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        width: "33.6%",
        mt: 1,
        "& .MuiButton-root": {
          fontSize: {
            md: theme.fontSizes.small,
            sm: theme.fontSizes.xsmall,
          },
          width: "100%",
        },
      }}
    >
      <Button
        variant={selected === "create" ? "contained" : "outlined"}
        color="success"
        onClick={() => handleClick("create")}
      >
        { rol === "Empleado" ? "Crear venta" : "Crear" }
      </Button>

      {rol === "Jefe" && (
        <Button
          variant={selected === "update" ? "contained" : "outlined"}
          color="primary"
          onClick={() => handleClick("update")}
        >
          Actualizar
        </Button>
      )}

      {rol === "Jefe" && (
        <Button
          variant={selected === "delete" ? "contained" : "outlined"}
          color="error"
          onClick={() => handleClick("delete")}
        >
          Eliminar
        </Button>
      )}
    </Stack>
  );
}
